import { gsap } from 'gsap'
import { deepMerge, getCubicCurve } from 'js/utils/Utils'

import Common from 'js/_core/Common'
import FadeInViewItem from 'js/modules/_base/effects/FadeInViewItem'
import FooterContactHover from 'js/modules/projects/events/mouse/hover/FooterContactHover'

const defaults = {
  instanceName: 'footerContactInViewItem',
  $names: {
    trigger: '[data-anim="footer-contact-iv"]',
    item: '[data-split-item],[data-anim="footer-contact_item-iv"]',
  },
}

export default class FooterContactInViewItem extends FadeInViewItem {
  constructor(options = {}) {
    super()
    this._iom = Common.iom3
    deepMerge(this, defaults, options)

    if (Common.useMouseHover) {
      this.footerContactHover = new FooterContactHover({
        $contentRoot: this.$contentRoot,
      })
    }
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
    this.footerContactHover?.destroy()
  }

  setInitialStyle($el, index) {
    gsap.set($el, {
      opacity: 0,
    })
  }

  async animateIn($el, index) {
    requestAnimationFrame(() => {
      const $items = $el.querySelectorAll(this.$names.item)
      gsap.set($el, {
        opacity: 1,
      })
      if ($items && $items.length > 0) {
        gsap.fromTo(
          $items,
          {
            y: '100%',
            rotate: 0.001,
            force3D: false,
          },
          {
            y: '0%',
            force3D: false,
            duration: 1,
            delay: 0.025,
            stagger: 0.025,
            ease: 'expo.out',
          }
        )

        gsap.delayedCall(0.85, () => {
          this.footerContactHover?.init()
        })
      }
    })
  }
}